var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTech2FlowIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.58,
    height: 74.687,
    viewBox: "0 0 84.08 73.94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#1b1c32;}.cls-3{fill:#00b2f2;}.cls-4{fill:url(#c);}.cls-5,.cls-8{mix-blend-mode:multiply;}.cls-5{fill:url(#b);}.cls-6{fill:url(#a);}.cls-7{fill:url(#e);}.cls-8{fill:url(#d);}.cls-9{fill:url(#i);}.cls-10{fill:url(#h);}.cls-11{fill:url(#g);}.cls-12{fill:url(#f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -174.92,
    x2: -191.64,
    y1: 216.73,
    y2: 255.18,
    gradientTransform: "rotate(.83 13126 16306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00b2f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3992",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -261.92,
    x2: -288.3,
    y1: 218.32,
    y2: 258.94,
    gradientTransform: "rotate(.83 12912 22454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b2a2a",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -180.09,
    x2: -197.11,
    y1: 252.27,
    y2: 263.56,
    gradientTransform: "rotate(.83 13126 16306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01f8f5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006ef0",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -189.77,
    x2: -208.79,
    y1: 206.87,
    y2: 241.42,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -278.08,
    x2: -298.49,
    y1: 204.63,
    y2: 239.15,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -207.56,
    x2: -224.04,
    y1: 216.22,
    y2: 225.93,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 427.43,
    x2: 444.44,
    y1: 595.84,
    y2: 632.43,
    gradientTransform: "rotate(90.83 529.2 151.18)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 417.35,
    x2: 435.45,
    y1: 622.17,
    y2: 660.07,
    gradientTransform: "rotate(90.83 529.2 151.18)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 391.17,
    x2: 407.95,
    y1: 622.11,
    y2: 659.91,
    gradientTransform: "rotate(90.83 529.2 151.18)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -174.92,
    x2: -191.64,
    y1: 216.73,
    y2: 255.18,
    gradientTransform: "rotate(.83 13126 16306)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -261.92,
    x2: -288.3,
    y1: 218.32,
    y2: 258.94,
    gradientTransform: "rotate(.83 12912 22454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -180.09,
    x2: -197.11,
    y1: 252.27,
    y2: 263.56,
    gradientTransform: "rotate(.83 13126 16306)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1",
    transform: "translate(.02 -.15558)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    transform: "translate(-5.94 -.47)",
    d: "m63.4 34.89-8-11.16-23.18 44.71c4.14 5.8 11.15 5 14.58-1.55z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    transform: "translate(-5.94 -.47)",
    d: "m63.4 34.89-8-11.16-23.18 44.71c4.14 5.8 11.15 5 14.58-1.55z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    transform: "translate(-5.94 -.47)",
    d: "m76.54 53.29-26.24 19c-6 4.33-13.36 2.76-18.08-3.85l26.24-19c5.99-4.34 13.36-2.77 18.08 3.85z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    transform: "translate(-5.94 -.47)",
    d: "m50.54 16.23c-4.14-5.8-11.14-5.06-14.54 1.55l-16.61 32c4.14 5.8 11.15 5 14.58-1.55z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    transform: "translate(-5.94 -.47)",
    d: "m50.72 16.23c-4.15-5.8-11.15-5.06-14.58 1.55l-16.61 32c4.15 5.8 11.15 5 14.58-1.55z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    transform: "translate(-5.94 -.47)",
    d: "m50.27 16.5-26.27 19c-6 4.33-13.35 2.76-18.08-3.85l26.25-19c6-4.34 13.37-2.77 18.1 3.85z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    transform: "translate(-5.94 -.47)",
    d: "m90 43.54-26.24 19c-6 4.33-13.36 2.76-18.08-3.85l26.24-19c5.99-4.33 13.36-2.76 18.08 3.85z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    transform: "translate(-5.94 -.47)",
    d: "m55.71 23.39 8 11.17-26.24 19c-6 4.33-13.36 2.76-18.08-3.85z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    transform: "translate(-5.94 -.47)",
    d: "m63.72 6.75-26.24 19c-6 4.33-13.35 2.76-18.08-3.85l26.25-19c5.98-4.33 13.35-2.76 18.07 3.85z",
    fill: "url(#f)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTech2FlowIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tech2flow-icon.558ea396.svg";
export { ForwardRef as ReactComponent };